import React from "react";

const ErrorComponent = () => {
  return <div>Oops!! Something went wrong. Please reload the page.</div>;
};

export default ErrorComponent;
